module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#3d3d3d\" class=\"asda-icon__draw\"><path d=\"M16 24a8 8 0 100-16 8 8 0 000 16zm0 2c-5.523 0-10-4.477-10-10S10.477 6 16 6s10 4.477 10 10-4.477 10-10 10z\"></path><path d=\"M13 20.128V11h3.136c.504 0 .975.049 1.414.147s.821.261 1.148.49.586.532.777.91.287.842.287 1.393c0 .532-.096.994-.287 1.386s-.45.714-.777.966-.705.439-1.134.56-.887.182-1.372.182h-1.134v3.094zm2.058-4.732h1.008c1.12 0 1.68-.485 1.68-1.456 0-.476-.15-.812-.448-1.008s-.728-.294-1.288-.294h-.952z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-park-ride.svg
// module id = 698
// module chunks = 0